import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import OnboardingNavItem from './OnboardingNavItem';
import withOnboarding from './withOnboarding';
import SVGChevron from '../../svg/Chevron';

class OnboardingNav extends React.Component {
  state = {
    isOpen: false
  };

  render() {
    return this.props.isMobile
      ? this.renderMobileNav()
      : this.renderDesktopNav();
  }

  renderMobileNav() {
    const { isOpen } = this.state;
    const classes = [
      'on-boarding__nav',
      'on-boarding-nav',
      'on-boarding-nav--mobile'
    ];

    // closed - show current step
    if (!isOpen) {
      const currentStep = this.getActiveStep();
      return (
        <div className={classes.join(' ')}>
          <div
            className="on-boarding-nav-item on-boarding-nav-item--active"
            onClick={this.toggleOpen}
          >
            {this.renderContent(currentStep)}
          </div>
        </div>
      );
    }

    // open - show all steps
    classes.push('on-boarding-nav--mobile-open');

    return (
      <div className={classes.join(' ')}>
        <div className="on-boarding-nav__button" onClick={this.toggleOpen}>
          <span>Steps</span>
          <div className="on-boarding-nav-item__chev">
            <span className="chev">
              <SVGChevron className="svg--flip-v" />
            </span>
          </div>
        </div>
        <ul className="on-boarding-nav-list">{this.renderListItems()}</ul>
      </div>
    );
  }

  renderDesktopNav() {
    const classes = ['on-boarding__nav', 'on-boarding-nav'];
    return (
      <div className={classes.join(' ')}>
        <ul className="on-boarding-nav-list">{this.renderListItems()}</ul>
      </div>
    );
  }

  renderListItems() {
    return [...this.props.steps].map((step, key) =>
      this.renderListItem(key, step)
    );
  }

  renderListItem(key, step) {
    const { progress } = this.props;
    const isActive = this.props.location.pathname === step.path;

    // define default classes
    const classes = ['on-boarding-nav-item'];

    // add the active class
    if (isActive) classes.push('on-boarding-nav-item--active');

    if (progress.includes(key) && !isActive)
      classes.push('on-boarding-nav-item--complete');

    // add disabled class (may not be necessary, depending on css)
    if (!progress.includes(key) && !isActive)
      classes.push('on-boarding-nav-item--disabled');

    return (
      <li key={key} className={classes.join(' ')}>
        {progress.includes(key) || isActive
          ? this.renderLink(step)
          : this.renderContent(step)}
      </li>
    );
  }

  renderLink(step) {
    return (
      <Link to={step.path} className="on-boarding-nav-link">
        {this.renderContent(step)}
      </Link>
    );
  }

  renderContent(step) {
    return (
      <OnboardingNavItem
        step={step}
        isMobile={this.props.isMobile}
        isOpen={this.state.isOpen}
        subject={this.props.subject}
        extras={this.props.extras}
      />
    );
  }

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  getActiveStep = () => {
    return (
      this.props.steps.filter(
        step => this.props.location.pathname === step.path
      )[0] || {}
    );
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ isOpen: false });
    }
  }

  static contextTypes = {
    steps: PropTypes.array,
    progress: PropTypes.array
  };
}

export default withRouter(withOnboarding(OnboardingNav));



// WEBPACK FOOTER //
// ./src/components/onboarding/OnboardingNav.js